import { useEffect } from "react";

const BASE = "Akwaba Admin";

/** Met à jour le titre de l'onglet (SPA : sinon toutes les pages partagent le titre du index.html). */
export function usePageTitle(title: string | null | undefined) {
	useEffect(() => {
		document.title = title ? `${title} — ${BASE}` : BASE;
		return () => {
			document.title = BASE;
		};
	}, [title]);
}
